const elements = document.querySelectorAll('[data-validation-type]')
const submitBtn = document.querySelectorAll(
    '[data-validation-type="form-submit"]'
)
let typingTimer

const loadingIcon = `
    <svg version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        width="30px" height="30px" viewBox="0 0 40 40" enable-background="new 0 0 40 40" xml:space="preserve">
        <path opacity="0.2" fill="#00B16A" d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946
            s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634
            c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"/>

        <g class="loading-icon-rotate">
            <path fill="#00B16A" d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0
                C22.32,8.481,24.301,9.057,26.013,10.047z">
            </path>
        </g>

    </svg>
`
const okIcon = `
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" width="15px" height="20px" viewBox="0 0 500 500" enable-background="new 0 0 500 500" xml:space="preserve">
    <rect fill="none" width="500" height="500"/>
    <path fill="#33C24D" d="M496.757,99.86c-10.55-27.205-32.047-22.91-55.341-18.295c-13.914,2.899-75.788,21.012-173.693,124.247  c-40.629,42.845-67.43,77.002-85.076,103.052c-10.779-13.234-23.128-27.394-36.098-40.368  c-39.885-39.874-84.362-67.256-86.232-68.407C41.652,188.678,17.286,194.55,5.843,213.2c-11.428,18.65-5.575,43.057,13.061,54.51  c0.381,0.24,38.577,23.854,71.573,56.86c33.65,33.654,64.138,79.164,64.438,79.604c7.422,11.16,19.886,17.672,32.997,17.672  c2.251,0,4.524-0.188,6.786-0.581c15.474-2.688,27.906-14.257,31.696-29.502c0.095-0.369,15.817-43.818,98.871-131.383  c66.894-70.551,111.502-92.974,126.96-99.193c0.146-0.025,0.257-0.037,0.455-0.078c-0.072,0.018,0.501-0.248,1.433-0.667  c2.653-0.995,4.075-1.376,4.155-1.396c-0.76,0.19-1.154,0.236-1.154,0.236l-0.028-0.137c7.153-3.12,20.542-8.88,20.836-9.004  C498.08,141.861,504.638,120.176,496.757,99.86z"/>
    </svg>
`

/**
 *
 * Get the closest ancestor.
 * @param {DOM Element} el
 * @param {DOM Element} selector
 * @returns
 */
function closest(el, selector) {
    const matchesSelector =
        el.matches ||
        el.webkitMatchesSelector ||
        el.mozMatchesSelector ||
        el.msMatchesSelector

    while (el) {
        if (matchesSelector.call(el, selector)) {
            return el
        } else {
            el = el.parentElement
        }
    }
    return null
}

/**
 * 
 * Apply validate style on element
 * @param {DOM Element} input 
 * @param {DOM Element} span 
 */
export function validatedStyle(input, span) {
    setTimeout(() => {
        if (input.nodeName == 'SELECT' || input.type == 'checkbox') {
            span.innerHTML = ''
        } else {
            span.innerHTML = okIcon
        }
        span.style.paddingTop = '5px'
        input.classList.remove('invalid')
        input.classList.add('valid')
        span.nextElementSibling.style.display = 'none'
    }, 500)

    span.style.paddingTop = '0'
    if (input.type == 'checkbox') {
        span.innerHTML = ''
    } else {
        span.innerHTML = loadingIcon
    }
}

/**
 * 
 * Apply not validate style on element
 * @param {DOM Element} input 
 * @param {DOM Element} span 
 * @param {String} message 
 */
export function notValidatedStyle(input, span, message) {
    setTimeout(() => {
        span.innerHTML = ''
        span.style.paddingTop = '5px'
        input.classList.remove('valid')
        input.classList.add('invalid')
        span.nextElementSibling.textContent = message
        span.nextElementSibling.style.display = 'block'
    }, 500)

    span.style.paddingTop = '0'
    if (input.type == 'checkbox') {
        span.innerHTML = ''
    } else {
        span.innerHTML = loadingIcon
    }
}

/**
 * 
 * Remove validation style
 * @param {DOM Element} input 
 * @param {DOM Element} span 
 */
export function removeValidatedStyle(input, span) {
    span.nextElementSibling.style.display = 'none'
    input.classList.remove('invalid')
    input.classList.remove('valid')
    span.style.paddingTop = '0'
    span.innerHTML = ''
}

/**
 * Return true if password enter serially
 * 
 * @param {DOM Element} input 
 * @returns 
 */
function serializePassword(input) {
    const value = input.value.split('')
    // let nextValue = 0
    // let matches = 0

    // for (let i of value) {
    //     let value = Number(i)
    //     if (value) {
    //         if (nextValue == value) {
    //             nextValue = value + 1
    //             matches ++
    //         } else {
    //             nextValue = value + 1
    //         }
    //     }
    // }

    //Return false if user type 8 numbers in serial
    // if (matches > 6) {
    //     return true
    // } else if (
    //     input.value == 'abcdefgh' ||
    //     input.value == 'abcdefg' ||
    //     input.value == 'abcdef' ||
    //     input.value == 'abcde'
    // ) {
    //     return true
    // }

    if (input.value == '12345678' || input.value == '23456789') {
        return true;
    } else if (
        input.value == 'abcdefgh' ||
        input.value == 'abcdefg' ||
        input.value == 'abcdef' ||
        input.value == 'abcde'
    ) {
        return true
    }
}

/**
 * Return true if password & email are same
 * 
 * @param {DOM Element} input 
 * @returns 
 */
function sameEmailPassword(input) {
    const form = closest(input, 'form')
    const email = form.querySelector('[type=email]')

    if (email) {
        if (input.value == email.value) {
            return true
        }
    }


}

/**
 * Return true if password & phone are same
 * 
 * @param {DOM Element} input 
 * @returns 
 */
function sameMobilePassword(input) {
    const form = closest(input, 'form')
    const phone = form.querySelector('[name="phone"]')

    if (phone) {
        if (input.value == phone.value) {
            return true
        }
    }


}

/**
 * 
 * Run validation on password field
 * return true if validation success
 * @param {DOM Element} input 
 * @param {DOM Element} span 
 * @returns 
 */
function validatePassword(input, span) {
    if (input.value.length == 0 && input.hasAttribute('required')) {
        const message = 'This field is required!'
        notValidatedStyle(input, span, message)
        return false
    } else if (input.value.length == 0 && !input.hasAttribute('required')) {
        removeValidatedStyle(input, span)
        return true
    } else if (input.value.length < 8) {
        const message = 'Password must contain at least 8 characters!'
        notValidatedStyle(input, span, message)
        return false
    } else if (serializePassword(input)) {
        const message = 'Your password is too easy to guess!'
        notValidatedStyle(input, span, message)
        return false
    } else if (sameEmailPassword(input)) {
        const message = 'Your email is not allowed as password!'
        notValidatedStyle(input, span, message)
        return false
    } else if (sameMobilePassword(input)) {
        const message = 'Your phone is not allowed as password!'
        notValidatedStyle(input, span, message)
        return false
    } else {
        validatedStyle(input, span)
        return true
    }
}

/**
 * 
 * Run validation on text field
 * return true if validation success
 * @param {DOM Element} input 
 * @param {DOM Element} span 
 * @returns 
 */
// function validateName(input, span) {
//     const nameRegex = /^[a-zA-Z-'. ]+$/;

//     if (input.value.length == 0 && input.hasAttribute('required')) {
//         const message = 'This field is required!'
//         notValidatedStyle(input, span, message)
//         return false
//     } else if (input.value.length == 0 && !input.hasAttribute('required')) {
//         removeValidatedStyle(input, span)
//         return true
//     } else if (!nameRegex.test(input.value)) {
//         const message = 'Please input your name correctly.'
//         notValidatedStyle(input, span, message)
//         return false
//     } else if (input.value.length < 3) {
//         const message = 'Your name should be greater than two charecters.'
//         notValidatedStyle(input, span, message)
//         return false
//     } else {
//         validatedStyle(input, span)
//         return true
//     }
// }
function validateName(input, span) {

    if (input.value.length == 0 && input.hasAttribute('required')) {
        const message = 'This field is required!'
        notValidatedStyle(input, span, message)
        return false
    } else if (input.value.length == 0 && !input.hasAttribute('required')) {
        removeValidatedStyle(input, span)
        return true
    } else {
        validatedStyle(input, span)
        return true
    }
}

/**
 * 
 * Run validation on textarea field
 * return true if validation success
 * @param {DOM Element} input 
 * @param {DOM Element} span 
 * @returns 
 */
function validateAddress(input, span) {
    if (input.value.length == 0 && input.hasAttribute('required')) {
        const message = 'This field is required!'
        notValidatedStyle(input, span, message)
        return false
    } else if (input.value.length == 0 && !input.hasAttribute('required')) {
        removeValidatedStyle(input, span)
        return true
    } else {
        validatedStyle(input, span)
        return true
    }
}

/**
 * 
 * Run validation on Terms & Condition
 * return true if validation success
 * @param {DOM Element} input 
 * @param {DOM Element} span 
 * @returns 
 */
function validateTermsCondition(input, span) {
    if (input.checked == false && input.hasAttribute('required')) {
        const message = 'Please accept terms & condition before continue!'
        notValidatedStyle(input, span, message)
        return false
    } else if (input.checked == false && !input.hasAttribute('required')) {
        removeValidatedStyle(input, span)
        return true
    } else {
        validatedStyle(input, span)
        return true
    }
}

/**
 * 
 * Run validation on email field
 * return true if validation success
 * @param {DOM Element} input 
 * @param {DOM Element} span 
 * @returns 
 */
export function validateEmail(input, span) {
    const emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    if (input.value.length == 0 && input.hasAttribute('required')) {
        const message = 'This field is required!'
        notValidatedStyle(input, span, message)
        return false
    } else if (input.value.length == 0 && !input.hasAttribute('required')) {
        removeValidatedStyle(input, span)
        return true
    } else if (!emailRegex.test(input.value)) {
        const message = 'Email format is not correct!'
        notValidatedStyle(input, span, message)
        return false
    } else if (input.className.includes('exist')) {
        const message = 'Email already registered.'
        notValidatedStyle(input, span, message)
        return false
    } else {
        validatedStyle(input, span)
        return true
    }
}

/**
 * 
 * Run validation on phone field
 * return true if validation success
 * @param {DOM Element} input 
 * @param {DOM Element} span 
 * @returns 
 */
export function validatePhone(input, span) {
    const phoneRegex = /^[\+|0-9]+$/;
    const phoneNumber = input.value.trim();
    if (phoneNumber.length == 0 && input.hasAttribute('required')) {
        const message = 'This field is required!'
        notValidatedStyle(input, span, message)
        return false
    } else if (phoneNumber.length == 0 && !input.hasAttribute('required')) {
        removeValidatedStyle(input, span)
        return true
    } else if (!phoneRegex.test(phoneNumber)) {
        const message = 'Only numbers are allowed.'
        notValidatedStyle(input, span, message)
        return false
    } else if (input.className.includes('exist')) {
        const message = 'Phone already registered.'
        notValidatedStyle(input, span, message)
        return false
    } else if (input.className.includes('not-acceptable')) {
        const message = 'Invalid phone number!'
        notValidatedStyle(input, span, message)
        return false
    } else {
        validatedStyle(input, span)
        return true
    }
}

/**
 * 
 * Run validation on select field
 * return true if validation success
 * @param {DOM Element} input 
 * @param {DOM Element} span 
 * @returns 
 */
function validateSelectMenu(input, span) {
    if (!input.value && input.hasAttribute('required')) {
        const message = 'This field is required!'
        notValidatedStyle(input, span, message)
        return false
    } else if (input.value == 0 && !input.hasAttribute('required')) {
        removeValidatedStyle(input, span)
        return true
    } else {
        validatedStyle(input, span)
        return true
    }
}

/**
 * 
 * Run validation on date field
 * return true if validation success
 * @param {DOM Element} input 
 * @param {DOM Element} span 
 * @returns 
 */

function validateNotBlank(input, span) {
    if (input.value.length == 0 && input.hasAttribute('required')) {
        const message = 'This field is required!'
        notValidatedStyle(input, span, message)
        return false
    } else if (input.value.length == 0 && !input.hasAttribute('required')) {
        removeValidatedStyle(input, span)
        return true
    } else {
        validatedStyle(input, span)
        return true
    }
}
/**
 * 
 * Run validation on date field
 * return true if validation success
 * @param {DOM Element} input 
 * @param {DOM Element} span 
 * @returns 
 */
function validateDate(input, span) {
    if (input.value.length == 0 && input.hasAttribute('required')) {
        const message = 'This field is required!'
        notValidatedStyle(input, span, message)
        return false
    } else if (input.value.length == 0 && !input.hasAttribute('required')) {
        removeValidatedStyle(input, span)
        return true
    } else {
        validatedStyle(input, span)
        return true
    }
}

/**
 *
 * Run different type of validation based on validation
 * type & return true if validation ok
 * @param {DOM Element} element
 * @param {DOM Element} child
 * @returns boolean
 */
function runValidation(element, child) {
    let flag = true
    let validate

    if (element.dataset.validationType == 'name') {
        validate = validateName(element, child)
        if (!validate) {
            flag = false
        }
    }

    if (element.dataset.validationType == 'email') {
        validate = validateEmail(element, child)
        if (!validate) {
            flag = false
        }
    }

    if (element.dataset.validationType == 'phone') {
        validate = validatePhone(element, child)
        if (!validate) {
            flag = false
        }
    }

    if (element.dataset.validationType == 'address') {
        validate = validateAddress(element, child)
        if (!validate) {
            flag = false
        }
    }

    if (element.dataset.validationType == 'date') {
        validate = validateDate(element, child)
        if (!validate) {
            flag = false
        }
    }

    if (element.dataset.validationType == 'select-menu') {
        validate = validateSelectMenu(element, child)
        if (!validate) {
            flag = false
        }
    }

    if (element.dataset.validationType == 'password') {
        validate = validatePassword(element, child)
        if (!validate) {
            flag = false
        }
    }

    if (element.dataset.validationType == 'terms-condition') {
        validate = validateTermsCondition(element, child)
        if (!validate) {
            flag = false
        }
    }

    if (element.dataset.validationType == 'not-blank') {
        validate = validateNotBlank(element, child)
        if (!validate) {
            flag = false
        }
    }

    return flag
}
/**
 * 
 * Prevent submitting form if any
 * runValidation function return false
 * @param {event} e 
 */
function submitForm(e) {
    let flag = true
    let position = []

    const form = closest(e.target, 'form');
    const captcha = form.querySelector('.g-recaptcha');
    const formFields = form.querySelectorAll('[data-validation-type]');

    if (captcha) {
        if (!grecaptcha.getResponse()) {
            flag = false;
            captcha.parentElement.querySelector('.validation-text').classList.remove('d-none');
        } else {
            captcha.parentElement.querySelector('.validation-text').classList.add('d-none');
        }
    }


    ;[].forEach.call(formFields, element => {
        if (element.hasAttribute('required')) {
            const child = element.parentNode.querySelector('.validation-icon')
            let validate = runValidation(element, child)
            if (!validate) {
                position.push(element.getBoundingClientRect().top + window.scrollY);
                flag = false;
            }
        }
    })

    if (!flag) {
        TweenLite.to(window, 0.5, {
            scrollTo: position[0] - 100,
            ease: Power1.easeIn
        })
        e.preventDefault()
    } else {
        form.classList.add('validated');
    }
}

if (elements) {
    ;[].forEach.call(elements, (element, index) => {
        const span = document.createElement('span')
        span.classList.add('validation-icon')
        element.parentNode.appendChild(span)
        const p = document.createElement('p')
        p.classList.add('validation-text')
        element.parentNode.appendChild(p)

        if (element.nodeName == 'TEXTAREA' || element.nodeName == 'INPUT') {
            element.addEventListener('keyup', event => {
                const child = element.parentNode.querySelector(
                    '.validation-icon'
                )
                clearTimeout(typingTimer)
                typingTimer = setTimeout(() => {
                    runValidation(element, child)
                }, 1000)
            })
        }

        element.addEventListener('change', event => {
            const child = element.parentNode.querySelector('.validation-icon')
            runValidation(element, child)
        })
    })
}

[].forEach.call(submitBtn, (btn) => btn.addEventListener('click', submitForm));

export default runValidation
